import { SMath } from 'smath';
/**
 * Convert RGB to HSL
 */
export function rgb2hsl(rgb) {
    const r = SMath.clamp(SMath.normalize(rgb.red, 0, 255), 0, 1);
    const g = SMath.clamp(SMath.normalize(rgb.green, 0, 255), 0, 1);
    const b = SMath.clamp(SMath.normalize(rgb.blue, 0, 255), 0, 1);
    const M = Math.max(r, g, b);
    const m = Math.min(r, g, b);
    const C = M - m;
    let H = 0;
    if (C !== 0) {
        if (M === r) {
            H = (g - b) / C + 6;
        }
        else if (M === g) {
            H = (b - r) / C + 2;
        }
        else if (M === b) {
            H = (r - g) / C + 4;
        }
    }
    const L = (M + m) / 2;
    let S = 0;
    if (L > 0 && L < 1) {
        S = C / (1 - Math.abs(2 * L - 1));
    }
    return { hue: (H % 6) * 60, saturation: S * 100, lightness: L * 100 };
}
/**
 * Convert HSL to RGB
 */
export function hsl2rgb(hsl) {
    const H = hsl.hue % 360;
    const S = SMath.clamp(SMath.normalize(hsl.saturation, 0, 100), 0, 1);
    const L = SMath.clamp(SMath.normalize(hsl.lightness, 0, 100), 0, 1);
    const C = (1 - Math.abs(2 * L - 1)) * S;
    const X = C * (1 - Math.abs(((H / 60) % 2) - 1));
    const m = L - C / 2;
    let r = 0;
    let g = 0;
    let b = 0;
    if (H < 60) {
        r = C;
        g = X;
    }
    else if (H < 120) {
        r = X;
        g = C;
    }
    else if (H < 180) {
        g = C;
        b = X;
    }
    else if (H < 240) {
        g = X;
        b = C;
    }
    else if (H < 300) {
        b = C;
        r = X;
    }
    else {
        b = X;
        r = C;
    }
    return { red: (r + m) * 255, green: (g + m) * 255, blue: (b + m) * 255 };
}
